import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  roles: []
}

// getters
export const getters = {
  administrator: state => state.roles.find(role => role.id == 1),
  manager: state => state.roles.find(role => role.id == 2),
  student: state => state.roles.find(role => role.id == 3),
  professional: state => state.roles.find(role => role.id == 4),
  recipient: state => state.roles.find(role => role.id == 5),

  roles: state => state.roles,
}

// mutations
export const mutations = {
  [types.FETCH_ROLES_SUCCESS] (state, { roles }) {
    state.roles = roles;
  },

  [types.FETCH_ROLES_FAILURE] (state) {
    state.roles = [
      { 'id': 1, 'title': 'administrator' },
      { 'id': 2, 'title': 'manager' },
      { 'id': 3, 'title': 'student' },
      { 'id': 4, 'title': 'professional' },
      { 'id': 5, 'title': 'recipient' }
    ];
  },
}

// actions
export const actions = {
  async fetchRoles ({ commit }) {
    try {
      const response = await axios.get(`/api/roles`)

      commit(types.FETCH_ROLES_SUCCESS, { roles: response.data })
    } catch (error) {
      console.error(error)
      commit(types.FETCH_ROLES_FAILURE)
    }
  },
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/roles.js